import React from 'react'
import styles from './SettingsSection.module.scss'

export const SettingsSection = ({title, children}) => (
  <div className={styles.SettingsSection}>
    <h2 data-alt>{title}</h2>
    {children}
  </div>
)
